import { render, staticRenderFns } from "./ElementStudioDefaultElements.vue?vue&type=template&id=76bc55f0&"
import script from "./ElementStudioDefaultElements.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioDefaultElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports